import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#4C4DEE",
  "stroke-width": "1.382",
  d: "M12.212.69c5.943 0 10.81 5.036 10.81 11.31s-4.867 11.31-10.81 11.31c-5.942 0-10.81-5.036-10.81-11.31S6.27.69 12.213.69Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4C4DEE",
  d: "M12.38 16.144q-.924 0-1.584-.3-.648-.3-1.068-.78l.816-1.116q.348.336.768.552t.9.216q.564 0 .9-.228a.78.78 0 0 0 .336-.672.98.98 0 0 0-.168-.576q-.168-.252-.612-.384t-1.272-.132v-1.248q1.032 0 1.416-.276a.89.89 0 0 0 .384-.744q0-.396-.24-.612-.24-.228-.696-.228-.408 0-.744.18-.324.18-.684.492l-.888-1.08q.528-.456 1.116-.708.588-.264 1.284-.264 1.176 0 1.896.552.732.54.732 1.536 0 .588-.336 1.008-.324.42-.936.684v.048q.66.192 1.08.66.432.456.432 1.2 0 .708-.396 1.212-.384.492-1.032.756a3.8 3.8 0 0 1-1.404.252"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }